<template lang="html">
  <div>
    <span :class="$style.prefix">power-bi-reports/</span>
    <span>{{ roleName }}</span>
  </div>
</template>

<script>
export default {
  props: {
    roleName: String
  }
}
</script>

<style lang="scss" module>
.prefix {
  opacity: 0.5;
}
</style>
